/** Binary min-heap of (index, key) pairs on typed arrays; grows as needed. */
export class MinHeap {
  private idx = new Int32Array(4096);
  private key = new Float64Array(4096);
  size = 0;

  push(i: number, k: number) {
    if (this.size === this.idx.length) {
      const a = new Int32Array(this.size * 2);
      a.set(this.idx);
      this.idx = a;
      const b = new Float64Array(this.size * 2);
      b.set(this.key);
      this.key = b;
    }
    const { idx, key } = this;
    let p = this.size++;
    while (p > 0) {
      const q = (p - 1) >> 1;
      if (key[q] <= k) break;
      idx[p] = idx[q];
      key[p] = key[q];
      p = q;
    }
    idx[p] = i;
    key[p] = k;
  }

  /** Removes and returns the index with the smallest key. The heap must not be empty. */
  pop(): number {
    const { idx, key } = this;
    const top = idx[0];
    const li = idx[--this.size];
    const lk = key[this.size];
    let p = 0;
    for (;;) {
      let c = 2 * p + 1;
      if (c >= this.size) break;
      if (c + 1 < this.size && key[c + 1] < key[c]) c++;
      if (key[c] >= lk) break;
      idx[p] = idx[c];
      key[p] = key[c];
      p = c;
    }
    idx[p] = li;
    key[p] = lk;
    return top;
  }
}
